import { TournamentField } from '../../types'

export const typeTransform = (EntitiesMap: TournamentField[]) => (value: number) =>
  EntitiesMap.find(({ id }) => id === value)
